"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'signIn',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        start: 1,
        total: 10,
        page_num: 1,
        info_id: this.$route.query.id
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'signin/recordList';
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};